module.exports = __webpack_public_path__ + "img/download.97d31b32.svg";